import { useState, useEffect } from "react";
import api from "../utils/api";
import socket from "../socket";
import { toast } from "react-toastify";

export const useReservations = (restaurantId) => {
  const [reservations, setReservations] = useState([]);

  const fetchUpcomingReservations = async () => {
    try {
      const res = await api.get(
        `/allocation/reservations/upcoming?restaurantId=${restaurantId}`,
      );
      setReservations(res.data);
    } catch (err) {
      console.error("Error loading upcoming reservations", err);
    }
  };

  useEffect(() => {
    if (!restaurantId) return;

    const handleResv = () => fetchUpcomingReservations();

    socket.on("reservation-created", handleResv);
    socket.on("reservation-accepted", handleResv);
    socket.on("reservation-cancelled", handleResv);

    return () => {
      socket.off("reservation-created", handleResv);
      socket.off("reservation-accepted", handleResv);
      socket.off("reservation-cancelled", handleResv);
    };
  }, [restaurantId]);

  const validatePhone = (phone) => /^[0-9]{10}$/.test(phone);

  const handleSubmitReservation = async (reservation) => {
    if (!validatePhone(reservation.phone)) {
      toast.error("Enter valid 10-digit mobile number");
      return false;
    }

    try {
      await api.post("/allocation/reservations/create", {
        ...reservation,
        restaurantId,
      });
      toast.success("Reservation created!");
      return true;
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to create reservation",
      );
      return false;
    }
  };

  const handleAcceptReservation = async (resv) => {
    try {
      await api.post(`/allocation/reservations/accept/${resv._id}`, {
        restaurantId,
      });
      toast.success("Reservation accepted and table occupied!");
      await fetchUpcomingReservations();
    } catch (err) {
      toast.error("Failed to accept reservation");
    }
  };

  const handleCancelReservation = async (resv) => {
    try {
      await api.delete(`/allocation/reservations/cancel/${resv._id}`, {
        data: { restaurantId },
      });
      toast.success("Reservation cancelled!");
      fetchUpcomingReservations();
    } catch (err) {
      toast.error("Failed to cancel reservation");
    }
  };

  return {
    reservations,
    fetchUpcomingReservations,
    handleSubmitReservation,
    handleAcceptReservation,
    handleCancelReservation,
  };
};
